;(function () {
	const SCROLL_SHOW_PX = 100
	const root = document.getElementById('nodus-floating-cart')
	if (!root) return

	const btn = root.querySelector('.nodus-floating-cart__btn')

	function syncCount() {
		const srcBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble')
		const fabBubble = root.querySelector('.nodus-floating-cart__count')
		if (!srcBubble || !fabBubble) return
		fabBubble.innerHTML = srcBubble.innerHTML
		fabBubble.style.display = window.getComputedStyle(srcBubble).display
	}

	function setVisible(visible) {
		root.classList.toggle('nodus-floating-cart--visible', visible)
		root.setAttribute('aria-hidden', visible ? 'false' : 'true')
		if (btn) btn.tabIndex = visible ? 0 : -1
	}

	function updateScrollVisibility() {
		const y = window.pageYOffset || document.documentElement.scrollTop
		setVisible(y > SCROLL_SHOW_PX)
	}

	let ticking = false
	function onScroll() {
		if (ticking) return
		ticking = true
		window.requestAnimationFrame(() => {
			updateScrollVisibility()
			ticking = false
		})
	}

	function init() {
		syncCount()
		updateScrollVisibility()
		window.addEventListener('scroll', onScroll, { passive: true })

		if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
			subscribe(PUB_SUB_EVENTS.cartUpdate, () => syncCount())
		}

		const icon = document.querySelector('#cart-icon-bubble')
		if (icon) {
			const mo = new MutationObserver(() => syncCount())
			mo.observe(icon, { subtree: true, characterData: true, childList: true, attributes: true })
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init)
	} else {
		init()
	}

	if (btn) {
		btn.addEventListener('click', (e) => {
			e.preventDefault()
			const drawer = document.querySelector('cart-drawer')
			if (drawer && typeof drawer.open === 'function') {
				drawer.open(btn)
			} else if (window.routes && window.routes.cart_url) {
				window.location.href = window.routes.cart_url
			}
		})
	}
})()
